import { createContext } from "react";

type PermissionContextType = {
	permissionLoading: boolean;
};

export const PermissionContext = createContext<PermissionContextType>({
	permissionLoading: true,
});
